import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const ProfileSettingsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 49 48">
    <path
      d="M19.8646 22.7647C25.212 22.7647 29.5469 18.3402 29.5469 12.8824C29.5469 7.42448 25.212 3 19.8646 3C14.5172 3 10.1823 7.42448 10.1823 12.8824C10.1823 18.3402 14.5172 22.7647 19.8646 22.7647Z"
      fill="#007549"
    />
    <path
      d="M21.4864 25.2847C20.9539 25.26 20.4213 25.2353 19.8646 25.2353C14.0068 25.2353 8.53631 26.8906 3.8646 29.7318C1.73449 31.0165 0.5 33.4376 0.5 35.9824V42.5294H22.9145C21.0023 39.7376 19.8646 36.3282 19.8646 32.6471C19.8646 30.0035 20.4697 27.5329 21.4864 25.2847Z"
      fill="#007549"
    />
    <path
      d="M45.8858 32.6471C45.8858 32.1035 45.8132 31.6094 45.7405 31.0906L48.5 28.5953L46.0794 24.3212L42.5696 25.5318C41.795 24.8647 40.9236 24.3459 39.9554 23.9753L39.2292 20.2941H34.3881L33.6619 23.9753C32.6936 24.3459 31.8222 24.8647 31.0477 25.5318L27.5378 24.3212L25.1172 28.5953L27.8767 31.0906C27.8041 31.6094 27.7315 32.1035 27.7315 32.6471C27.7315 33.1906 27.8041 33.6847 27.8767 34.2035L25.1172 36.6988L27.5378 40.9729L31.0477 39.7624C31.8222 40.4294 32.6936 40.9482 33.6619 41.3188L34.3881 45H39.2292L39.9554 41.3188C40.9236 40.9482 41.795 40.4294 42.5696 39.7624L46.0794 40.9729L48.5 36.6988L45.7405 34.2035C45.8132 33.6847 45.8858 33.1906 45.8858 32.6471ZM36.8086 37.5882C34.146 37.5882 31.9675 35.3647 31.9675 32.6471C31.9675 29.9294 34.146 27.7059 36.8086 27.7059C39.4713 27.7059 41.6498 29.9294 41.6498 32.6471C41.6498 35.3647 39.4713 37.5882 36.8086 37.5882Z"
      fill="#007549"
    />
  </SvgIcon>
);
